const automations = {
  pageName: 'אוטומציות',
  btnCreate: 'הוסף',
  btnUseTemplate: 'השתמש בתבנית',
  mainTabs: {
    titleAutomationsCenter: 'מרכז אוטומציות',
    titleAutomationsExisting: 'אוטומציות קיימות',
  },
  deleteModal: {
    header: 'מחק אוטומציות',
    body: 'אתה עומד למחוק {{num}} אוטומציות.',
    success: 'האוטומציות נמחקו בהצלחה',
  },
  table: {
    header: {
      name: 'שם',
      nextRun: 'הרצה הבאה',
      lastRun: 'הרצה אחרונה',
      createdAt: 'תאריך יצירה',
      createdBy: 'נוצר על ידי',
      actionType: 'סוג פעולה',
      status: 'סטטוס',
      profiles: 'פרופילים',
      suppliers: 'ספקים',
      attributes: 'מאפיינים',
      areas: 'אזור',
      run: 'הפעל',
    },
    filters: {
      status: {
        title: 'סטטוס',
        options: {
          on: 'בתאריך',
          off: 'כבוי',
        },
      },
      profiles: {
        title: 'פרופילים',
      },
      suppliers: {
        title: 'ספקים',
      },
      attributes: {
        title: 'מאפיינים',
      },
      areas: {
        title: 'אזור',
      },
      actionType: {
        title: 'סוג פעולה',
        options: {
          routingProcess: 'תהליך הפקה',
          busRoute: 'מסלול אוטובוס',
          driverAssignment: 'ציוות נהג',
        },
      },
    },
    actions: {
      run: 'הפעל עכשיו',
      duplicate: {
        title: 'שכפל',
      },
      delete: {
        title: 'מחק',
      },
    },
    toasts: {
      delete: {
        success: 'נמחק בהצלחה!',
        error: 'אירעה שגיאה! לא ניתן למחוק אזור',
      },
      run: {
        success: 'האוטומציה נכנסה לתור. היא תופעל בקרוב',
        error: 'אירעה שגיאה! לא ניתן להפעיל את האוטומציה',
      },
    },
  },
  wizard: {
    titleCreate: 'הוסף',
    titleUpdate: 'עדכן',
    trigger: {
      title: '1. טריגר',
      subTitle: 'טריגר הוא אירוע שמתחיל את האוטומציה שלך',
      loadingText: 'אנא המתן\nטוען פרמטרים.',
      selectTrigger: {
        label: 'טריגר',
      },
      btnContinue: 'המשך',
    },
    action: {
      title: '2. פעולות',
      subTitle: 'הפעולה שנבחר היא אירוע המבוצע לאחר שהאוטומציה מתחילה לעבוד',
      loadingText: 'אנא המתן\nטוען פרמטרים.',
      selectAction: {
        label: 'פעולה',
      },
      btnContinue: 'המשך',
    },
    information: {
      title: '3. מידע',
      subTitle: 'מידע כללי על האוטומציה',
      name: 'שם האוטומציה',
      description: 'תיאור',
      profile: 'פרופיל',
      attributes: 'מאפיינים',
      supplier: 'ספק',
      areas: 'אזור',
      btnSubmit: 'שמור',
    },
  },
  automationsCenter: {
    tabs: {
      all: 'הכל',
      routingProcess: 'תהליך הפקה',
      busRoute: 'מסלול אוטובוס',
      driverAssignment: 'ציוות נהג',
    },
  },
  toasts: {
    error: 'משהו השתבש',
    successCreated: 'נוצר בהצלחה',
    successUpdated: 'עודכן בהצלחה',
  },
};

export default automations;
